export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11906.500d16fb.jpg";